import { Timestamp } from '@bufbuild/protobuf';
import { IntlShape } from 'react-intl';

import { API_KEY_DATE_FORMAT, EMPTY_VALUE } from '../config/constants';

export const formatApiKeyTimestamp = (
  formatDate: IntlShape['formatDate'],
  timestamp?: Timestamp,
): string =>
  timestamp ? formatDate(timestamp.toDate(), API_KEY_DATE_FORMAT) : EMPTY_VALUE;
